import { Box, Stack, StackProps, Typography } from "@mui/material";

export interface CalendarLegendProps {
  keys: string[];
}

export const CalendarLegend = ({
  keys,
  ...rest
}: CalendarLegendProps & StackProps) => (
  <Stack direction="row" gap={200} alignItems="center" {...rest}>
    {keys.map((key, index) => (
      <Stack direction="row" gap={50} key={key}>
        <Box
          width={({ tokens }) => tokens.typography.fontSize[4]}
          height={({ tokens }) => tokens.typography.fontSize[4]}
          borderRadius="100px"
          bgcolor={({ tokens }) =>
            [
              tokens.component.calendar.surfaceGood,
              tokens.component.calendar.surfaceAverage,
              tokens.component.calendar.surfaceBad,
              tokens.component.calendar.surfaceTerrible,
            ].at(index)
          }
        />
        <Typography
          variant="labelMedium"
          color={({ tokens }) =>
            [
              tokens.component.calendar.textGood,
              tokens.component.calendar.textGood,
              tokens.component.calendar.textAverage,
              tokens.component.calendar.textBad,
              tokens.component.calendar.textTerrible,
            ].at(index)
          }
        >
          {key}
        </Typography>
      </Stack>
    ))}
  </Stack>
);
